//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import OddsCard from '../components/OddsCard'

const months = ['month.jan', 'month.feb', 'month.mar', 'month.apr', 'month.may', 'month.jun', 'month.jul', 'month.aug', 'month.sep', 'month.oct', 'month.nov', 'month.dec']
const weeks = ['week.sun', 'week.mon', 'week.tues', 'week.web', 'week.thur', 'week.fri', 'week.sat']
const intervals = { 0: 30000, 1: 10000, 2: 30000, 3: 60000 }

export default {
  name: 'Ix2',
  components: {
    OddsCard
  },
  data () {
    return {
      sports: [],
      timestamp: 0,
      sportsbook: ['', 'live', 'today', 'early'],
      betTypes: '11005,11008',
      selectedOddsType: 'DEC',
      selectedTime: this.$route.params.sportsbook,
      loading: false,
      clock: null,
      checkedAllLeauge: false,
      checkedLeagues: [],
      sorts: [
        { name: 'league', value: 1 },
        { name: 'time', value: 2 }
      ],
      selectedSort: this.$store.state.profiles.sort,
      favorites: this.$store.state.profiles.favorites
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.sports = []
    this.timestamp = 0
    this.loadOdds(to.params)
    next()
  },
  mounted () {
    this.loadOdds(this.$route.params)

    this.$watch('selectedSort', (newVal, oldVal) => {
      if (oldVal) {
        this.$store.commit('profiles', { sort: newVal })
        this.sports = []
        this.timestamp = 0
        this.loadOdds(Object.assign(this.$route.params, { timestamp: 0, sort: newVal }))
      }
    })

    this.$watch('$i18n.locale', (newVal, oldVal) => {
      if (oldVal) {
        this.sports = []
        this.timestamp = 0
        if (this.clock) {
          window.clearInterval(this.clock)
        }
        this.loadOdds(this.$route.params)
      }
    },
      { immediate: true })
  },
  destroyed () {
    console.log("shutdown")
    if (this.clock) {
      window.clearInterval(this.clock)
    }
  },
  computed: {
    title: function () {
      let timestamp = this.$route.params.sportsbook;
      return this.sportsbook.length < timestamp ? this.sportsbook[3] : this.sportsbook[timestamp]
    },
    loggedOn: function () {
      return this.$store.state.loggedOn;
    },
    dates: function () {
      var result = []
      var dt = new Date()
      for (var i = 1; i <= 7; i++) {
        dt.setDate(dt.getDate() + 1)
        const name = `${dt.getDate()}/${this.$t(months[dt.getMonth()])} (${this.$t(weeks[dt.getDay()])})`
        const time = Date.UTC(dt.getFullYear(), dt.getMonth(), dt.getDate()) / 1000
        result.push({ name, time })
      }
      return [{ name: this.$t('sportsbook.all'), time: 3 }, ...result]
    },
    leagues: function () {
      let keys = {}
      return this.sports.flatMap(type => type.slice(5)).map(league => [league[0], league[1]])
        .filter(val => (keys[val[0]]) ? false : keys[val[0]] = true)

    }
  },
  watch: {
    checkedAllLeauge: function (newVal) {
      this.checkedLeagues = newVal ? this.leagues : []
    }
  },
  methods: {
    isValid: function (model) {
      return 'sportsbook' in model && 'sportId' in model
    },
    loadOdds: function (model) {

      if (this.isValid(model)) {
        this.loading = true

        this.$store.dispatch('loadOdds', Object.assign(model, { timestamp: this.timestamp, oddsType: this.selectedOddsType, betTypes: this.betTypes }))
          .then(data => {
            if (data.sports.length > 0) {
              if (this.sports.length === 0 || this.timestamp === 0) {
                this.sports = data.sports
              }
              else {
                console.log(data)

                data.sports.forEach(sport => {
                  // If live then remove from today or early
                  if (sport[0] === 1) {
                    var leagues = sport.slice(5).map(league => [league[0], league.slice(4).map(match => match[0])])
                    console.log(leagues)
                    leagues.forEach(league => {
                      for (var i = 0; i < this.sports.length; i++) {
                        if (this.sports[i][0] !== 1) {
                          for (var l = 5; l < this.sports[i].length; l++) {
                            if (league[0] === this.sports[i][l][0]) {
                              league[1].forEach(match => {
                                for (var m = 4; m < this.sports[i][l].length; m++) {
                                  if (match === this.sports[i][l][m][0]) {
                                    this.sports[i][l].splice(m, 1)
                                  }
                                }
                              })

                              // If no matches remove league
                              if (this.sports[i][l].length < 5) {
                                this.sports[i].splice(l, 1)
                              }

                              break;
                            }
                          }
                        }
                      }
                    })
                  }

                  var i = this.sports.findIndex(t => t[0] === sport[0])
                  if (i === -1) {
                    var t = this.sports.findIndex(t => t[0] > sport[0]);
                    // Filter close
                    var newLeagues = sport.slice(5).map(league => league.slice(0, 4).concat(league.slice(4).filter(m => m.length > 16)))
                    sport = sport.slice(0, 5).concat(newLeagues.filter(l => l.length > 4))

                    if (sport.length > 5) {
                      if (t === -1) {
                        this.sports.push(sport)
                      } else {
                        this.sports.splice(t, 0, sport)
                      }
                    }
                  } else {
                    var changedLeagues = sport.slice(5).map(league => {
                      var changedMatches = league.slice(4)
                      var oldMatches = this.sports[i].filter((v, i) => i > 4 && v[0] === league[0])
                        .flatMap(e => e)
                        .filter((v, i) => i > 3 && changedMatches.findIndex(m => m[0] == v[0]) === -1)
                      var newMatches = changedMatches.filter(m => m.length > 16)
                        .concat(oldMatches).sort((m1, m2) => m1[14] - m2[14])
                      var changedLeague = league.slice(0, 4).concat(newMatches)

                      return changedLeague;
                    })

                    sport = sport.slice(0, 5).concat(
                      changedLeagues.filter(l => l.length > 4).concat(this.sports[i].filter((v, i) => i > 4 && changedLeagues.findIndex(l => l[0] === v[0]) == -1))
                        .sort((l1, l2) => l1[3] - l2[3])
                    )

                    this.sports.splice(i, 1, sport)
                  }
                })
              }
            }

            this.timestamp = data.timestamp
            this.loading = false

            // Start clock
            if (!this.clock) {
              let sb = this.sports.length > 0 ? Math.min(...this.sports.map(m => m[0])) : 0
              let timeout = intervals[sb]
              console.log(`Starting clock and reload odds at ${timeout / 1000}s after.`)
              this.clock = window.setInterval(() => {
                console.log(`Fetch odds at ${this.timestamp}.`)
                this.loadOdds(Object.assign(this.$route.params, { timestamp: this.timestamp }))
              }, timeout)
            }
          })
      }
      else if ('sportsbook' in model && 'sports' in model) {
        this.loading = true
        this.$store.dispatch('loadOddsWithSports', Object.assign(model, { oddsType: this.selectedOddsType }))
          .then(data => {
            this.sports = data.sports
            this.timestamp = data.timestamp
            this.loading = false
          })
      }
    },
    allFavorite: function (events) {
      return events.filter(e => this.favorites.indexOf(e) == -1).length === 0
    },
    setFavorites: function (events, all = false) {
      let adds = [], removes = []
      if (all) {
        if (events.filter(e => this.favorites.indexOf(e[0]) > -1).length == events.length) {
          removes = events
          events.forEach(e => {
            let i = this.favorites.indexOf(e[0])
            if (i > -1) {
              this.favorites.splice(i, 1)
            }
          })
        } else {
          adds = events
          events.forEach(e => {
            let i = this.favorites.indexOf(e[0])
            if (i == -1) {
              this.favorites.push(e[0])
            }
          })
        }
      } else {
        events.forEach(e => {
          let i = this.favorites.indexOf(e[0])
          if (i == -1) {
            this.favorites.push(e[0])
            adds.push(e)
          } else {
            this.favorites.splice(i, 1)
            removes.push(e)
          }
        })
      }

      if (adds.length) {
        this.$store.dispatch('addFavorites', adds)
      }

      if (removes.length) {
        this.$store.dispatch('removeFavorites', removes)
      }
    },
    activeOdds (odds) {
      return odds.length === 0 ? [[], [], []] : odds.slice(3);
    },
    betting: function (odds) {
      if (this.loggedOn) {
        this.$store.commit('active', 'betslip')
        this.$store.dispatch('checkBetting', {
          marketId: odds[0],
          handicap: odds[2],
          stakeNumber: odds[3],
          odds: odds[5],
          oddsType: this.$store.state.profiles.oddsType
        })
      }
    },
    dateChanges: function (date) {
      this.selectedTime = date.time
      this.sports = []
      this.timestamp = 0
      this.loadOdds(Object.assign(this.$route.params, { sportsbook: date.time, timestamp: 0 }))
    },
    isCheckedLeague: function (id) {
      return this.checkedLeagues.length === 0 || this.checkedLeagues.filter(val => val[0] === id).length > 0
    }
  }
}
